'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (domElement, callback) {
  if (global.MutationObserver == null && global.ResizeObserver == null) {
    return function () {};
  }

  if (global.ResizeObserver == null) {
    var recordedSize = {};

    var onChange = function onChange() {
      var boundingClientRect = domElement.getBoundingClientRect();

      if (boundingClientRect.width !== recordedSize.width || boundingClientRect.height !== recordedSize.height || boundingClientRect.top !== recordedSize.top || boundingClientRect.left !== recordedSize.left || boundingClientRect.right !== recordedSize.right || boundingClientRect.bottom !== recordedSize.bottom || boundingClientRect.x !== recordedSize.x || boundingClientRect.y !== recordedSize.y) {
        recordedSize = boundingClientRect;
        callback(recordedSize);
      }
    };

    var _observer = new global.MutationObserver(onChange);

    global.addEventListener('resize', onChange);

    _observer.observe(domElement, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true
    });

    callback(domElement.getBoundingClientRect());

    return function () {
      _observer.disconnect();
      global.removeEventListener('resize', onChange);
    };
  }

  var observer = new global.ResizeObserver(function () {
    return callback(domElement.getBoundingClientRect());
  });

  observer.observe(domElement);

  return function () {
    return observer.disconnect();
  };
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/element-rect-observer/dist/resizeObserver.js
// module id = 470
// module chunks = 0